/**
 * The plaintext inside an MLS application message. Everything a user does in an E2EE
 * DM (send, edit, delete, react) is one of these, so the server only ever sees opaque
 * ciphertext plus routing metadata (channel, sender device, time).
 */
import { utf8 } from './encoding.js';
/** Pad plaintext to a multiple of 256 bytes so message length leaks less. */
const BLOCK = 256;
export function sealEnvelope(env) {
    const body = utf8.encode(JSON.stringify(env));
    const padded = new Uint8Array(Math.ceil((body.length + 4) / BLOCK) * BLOCK);
    new DataView(padded.buffer).setUint32(0, body.length);
    padded.set(body, 4);
    return padded;
}
export function openEnvelope(bytes) {
    if (bytes.length < 4)
        throw new Error('envelope too short');
    const len = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getUint32(0);
    if (len > bytes.length - 4)
        throw new Error('bad envelope length');
    const env = JSON.parse(utf8.decode(bytes.subarray(4, 4 + len)));
    if (env?.v !== 1 || typeof env.type !== 'string')
        throw new Error('unsupported envelope');
    return env;
}
//# sourceMappingURL=envelope.js.map